import moment from 'moment';

const _durationKeys = [
  { key: 'days', value: 'd' },
  { key: 'hours', value: 'h' },
  { key: 'minutes', value: 'm' },
  { key: 'seconds', value: 's' },
];

const granularTime = time => moment(time).format('MMM Do, YYYY [at] h:mma');

const timeDiff = (startTime, endTime, pad = false) => {
  const diff = moment(startTime).diff(endTime, 'seconds');
  const duration = moment.duration(diff, 'seconds');
  const resultArray = [];

  _durationKeys.forEach(dk => {
    let dur = duration.get(dk.key);

    if (pad && dk.key === 'seconds') {
      dur = `${dur < 10 ? 0 : ''}${dur}`;
    }

    if (resultArray.length || dur) {
      resultArray.push(`${dur}${dk.value}`);
    }
  });

  return resultArray.join(' ');
};

const timeDiffNow = (time, pad = false) => timeDiff(moment(), time, pad);
// const timeSinceNow = time => moment(time).fromNow();

export default {
  granularTime,
  timeDiff,
  timeDiffNow,
};



// WEBPACK FOOTER //
// ./src/utils/format.js